import InvelpsLogin from "./InvelpsLogin";

export default function LoginForm() {
  return <InvelpsLogin />;
}
